import { Suspense, useContext, useRef } from "react";
import { Box } from "@mui/material";
import { AuthContext } from "../auth/Auth";
import { useLoginState } from "../studioxr/auth/LoginState";
import { lazyWithRetry } from "../utils/lazyWithRetry";
import { MarketingNav } from "./MarketingNav";

// Lazy so the public pages add no static import of Bar and its graph.
const Bar = lazyWithRetry(() => import("../auth/Bar").then((m) => ({ default: m.Bar })));

// Top nav for the public pages inside the app: the marketing nav signed out,
// the app Bar signed in. A visitor who signs in or up keeps the marketing nav
// until the auth modal closes: Firebase sets currentUser while the modal still
// has steps to run, and swapping would unmount the modal mid-flow.
export const SiteNav = () => {
  const { currentUser } = useContext(AuthContext);
  const showLogin = useLoginState((state) => state.showLogin);
  const marketing = useRef(!currentUser);
  if (!currentUser) marketing.current = true;
  else if (!showLogin) marketing.current = false;
  return marketing.current ? <MarketingNav /> : <Suspense fallback={<Box sx={{ height: 50 }} />}><Bar /></Suspense>;
};

// For the pages that frame a blog page full-screen: sits on top of the frame
// and covers the framed page's own nav, as the old header did.
export const FixedSiteNav = () => (
  <Box sx={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 999, minHeight: 76, bgcolor: "#fff" }}>
    <SiteNav />
  </Box>
);
